import { getUncroppedSamplingAreasByFarm } from './getSamplingAreas'
import { createSamplingAreasFeatureByFarm } from './saveSamplingAreas'

export const samplingAreas = {
  getUncroppedByFarm: getUncroppedSamplingAreasByFarm,
  createByFarm: createSamplingAreasFeatureByFarm,
}
